import { FormEdit } from './form-edit.component'
import { FormAddition } from './form-addition.component'

import { IStepFormProps } from '..'

interface IProps {
  isDisabled?: boolean
  locale?: string
  handleLocale?: (locale: string) => void
}

interface IStepFormMobileProps extends IStepFormProps, IProps {}

const StepFormMobile = ({
  isAddingNew,
  isDisabled,
  locale,
  handleLocale,
}: IStepFormMobileProps) => {
  return isAddingNew ? (
    <FormAddition isDisabled={isDisabled} locale={locale} />
  ) : (
    <FormEdit isDisabled={isDisabled} locale={locale} handleLocale={handleLocale} />
  )
}

export { StepFormMobile }
